(function(){
  var form = document.getElementById('pk-form');
  if(!form) return;
  var note = document.getElementById('pk-note');
  var submit = document.getElementById('pk-submit');
  var COMPANY = form.getAttribute('data-company');
  var LIST = form.getAttribute('data-list');
  function setNote(msg, ok){ note.textContent = msg; note.className = 'pk-note ' + (ok ? 'pk-ok' : 'pk-err'); }
  form.addEventListener('submit', function(e){
    e.preventDefault();
    var email = form.email.value.trim();
    var name = form.name.value.trim();
    if(!email || email.indexOf('@') === -1){ setNote('Missing the rest after the @.', false); return; }
    submit.disabled = true; submit.textContent = 'Sending…';
    var payload = { data: { type: 'subscription', attributes: {
      custom_source: 'The Pack landing page',
      profile: { data: { type: 'profile', attributes: {
        email: email, first_name: name,
        properties: { pack_status: 'applied', ig_handle: form.handle.value.trim(), applicant_city: form.city.value.trim(), dog_name: form.dog.value.trim(), why_join: form.why.value.trim(), applied_from: 'the-pack-landing' }
      }}}
    }, relationships: { list: { data: { type: 'list', id: LIST } } } } };
    fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(COMPANY), {
      method: 'POST', headers: { 'Content-Type': 'application/json', 'revision': '2024-10-15' }, body: JSON.stringify(payload)
    }).then(function(res){
      if(res.status === 202 || res.ok){ form.reset(); setNote("You're in the pile. Watch your inbox.", true); submit.textContent = 'Sent'; }
      else { return res.text().then(function(t){ throw new Error(t || res.status); }); }
    }).catch(function(err){ setNote('Something went sideways — try again in a moment.', false); submit.disabled = false; submit.textContent = 'Send it'; });
  });
})();
